/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Noorganization1Inputs */

const zh_share_noorganization1 = /** @type {(inputs: Share_Noorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无组织。`)
};

const en_share_noorganization1 = /** @type {(inputs: Share_Noorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No organization yet.`)
};

const es_share_noorganization1 = /** @type {(inputs: Share_Noorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no tienes organización.`)
};

/**
* | output |
* | --- |
* | "No organization yet." |
*
* @param {Share_Noorganization1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_noorganization1 = /** @type {((inputs?: Share_Noorganization1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Noorganization1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_noorganization1(inputs)
	if (locale === "en") return en_share_noorganization1(inputs)
	return es_share_noorganization1(inputs)
});
export { share_noorganization1 as "share_noOrganization" }